import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=367d1b2a&scoped=true"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=367d1b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d1b2a",
  null
  
)

export default component.exports